import React from "react";

import Box from "@mui/material/Box";

const TooltipContainer = ({ children, color = "#F07C00", sx }) => {
	return (
		<Box
			sx={{
				border: "1px solid #F07C00",
				borderTop: "6px solid #F07C00",
				color: "#7F7F7F",
				padding: "20px 18px",
				borderColor: color,
				...sx
			}}
		>
			{children}
		</Box>
	);
};

export default TooltipContainer;
